import { Collapse, List, ListItem, ListItemText, Theme } from '@mui/material';
import { makeStyles, createStyles } from '@mui/styles';
import { Fragment, ReactElement, useState } from 'react';
import { Link } from 'react-router-dom';
import { ExpandLess, ExpandMore } from '@mui/icons-material';
import { useCallback } from 'react';
import { DisabledGeographicMenu } from 'shell/view-models/disabled-menu';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    nested: {
      paddingLeft: `${theme.spacing(4)} !important`,
    },
    nestedIcon: {
      minWidth: 'auto !important',
      paddingRight: theme.spacing(2),
      color: `#555 !important`,
      // color: `${theme.palette.common.white} !important`,
    },
    colorItems: {
      // color: `${theme.palette.common.white} !important`,
      color: `#555 !important`,
    },
  })
);

interface GeographicCollapseProps {
  onSubItemClick?: () => void;
  link: string;
  active: DisabledGeographicMenu;
}

const GeographicCollapse = ({
  onSubItemClick,
  link,
  active,
}: GeographicCollapseProps): ReactElement => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleClick = useCallback(() => {
    setOpen(!open);
  }, [setOpen, open]);

  return (
    <Fragment>
      <ListItem
        button
        key="Geografiche"
        onClick={() => {
          handleClick();
        }}
        sx={{ pl: 6 }}
        className={classes.colorItems}
      >
        <ListItemText className={classes.colorItems} primary="Geografiche" />
        {open ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={open} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          {active.municipality ? (
            <Link
              key={`${link}/geografiche/comune`}
              to={`${link}/geografiche/comune`}
              className="pmi-anchor"
            >
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Comune" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.region ? (
            <Link to={`${link}/geografiche/italia/regione`} className="pmi-anchor">
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Regione" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.province ? (
            <Link to={`${link}/geografiche/italia/provincia`} className="pmi-anchor">
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Provincia" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.state ? (
            <Link to={`${link}/geografiche/estero/stato`} className="pmi-anchor">
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Stato Estero" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.territory ? (
            <Link to={`${link}/geografiche/estero/territorio`} className="pmi-anchor">
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Territorio" />
              </ListItem>
            </Link>
          ) : undefined}
          {active.consulate ? (
            <Link to={`${link}/geografiche/estero/consolato`} className="pmi-anchor">
              <ListItem button onClick={onSubItemClick} sx={{ pl: 8 }}>
                <ListItemText className={classes.colorItems} primary="Consolato" />
              </ListItem>
            </Link>
          ) : undefined}
        </List>
      </Collapse>
    </Fragment>
  );
};

GeographicCollapse.displayName = 'Geographic Collapse Item';

export default GeographicCollapse;
